import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  FormControlLabel,
  Typography,
} from "@mui/material"

import { Form, Formik } from "formik"
import { useState } from "react"
import * as Yup from "yup"
import { inquiryFormValues } from "./inquiryFormValues"
import MyTextInput from "../../common/forms/MyTextInput"
import MyTextArea from "../../common/forms/MyTextArea"
import LoadingButton from "@mui/lab/LoadingButton/LoadingButton"
import PrivacyAgreement from "./PrivacyAgreement"
import { useNavigate } from "react-router-dom"
import { init, send } from "@emailjs/browser"

const sleep = (delay: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, delay)
  })
}

const userID = process.env.REACT_APP_EMAILJS_API_KEY
const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID
const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID

export default function InquiryPage() {
  const [loading, setLoading] = useState<boolean>(false)
  const [inquiry, setInquiry] = useState<inquiryFormValues>({
    name: "",
    // firstname: "",
    company: "",
    email: "",
    phone: "",
    description: "",
  })
  const [checked, setChecked] = useState<boolean>(false)
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
  }
  const [open, setOpen] = useState<boolean>(false) //Modal
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  const navigate = useNavigate()

  const validationSchema = Yup.object({
    name: Yup.string().required("必須"),
    company: Yup.string(),
    email: Yup.string().email().required("必須"),
    phone: Yup.string()
      .matches(phoneRegExp, "有効な番号ではありません")
      .required("必須"),
    description: Yup.string().required("必須"),
  })

  async function handleFormSubmit(inquiry: inquiryFormValues) {
    //Send email
    setLoading(true)
    // console.log("the form inquiry is ", inquiry)
    if (userID && serviceID && templateID) {
      init(userID)
      const params = {
        name: inquiry.name,
        company: inquiry.company,
        email: inquiry.email,
        phone: inquiry.phone,
        description: inquiry.description,
      }
      try {
        await send(serviceID, templateID, params, userID)
        await sleep(1000)
        navigate("/inquiry/complete", { replace: true })
        setOpen(false)
      } catch (error) {
        setOpen(false)
      }
    }
    setLoading(false)
    // if (item.id.length === 0) {
    //   let newItem = {
    //     ...item,
    //     id: uuid(),
    //   }
    //   await createItem(newItem, imageFiles)
    //   //await loadItems()
    //   navigate("/items", { replace: true })
    // } else {
    //   updateItem(item, imageFiles).then(() => {
    //     navigate("/items", { replace: true })
    //   })
    // }
  }
  return (
    <Box
      sx={{
        mx: { xs: "1em", sm: "5em", md: "15em", lg: "20em", xl: "25em" },
        mb: "5em",
        pt: "2em",
      }}
    >
      <Typography variant="h4" sx={{ textAlign: "center", fontWeight: "bold" }}>
        ご登録・お問い合わせ
      </Typography>
      <Formik
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={inquiry}
        onSubmit={(values) => handleFormSubmit(values)}
      >
        {({ submitForm, isValid, isSubmitting, dirty, values }) => (
          <Form autoComplete="on">
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <MyTextInput name="name" label="お名前" type="text" />
              {/* <MyTextInput name="firstname" label="名" type="text" /> */}
              <MyTextInput name="company" label="企業名" type="text" />
              <MyTextInput name="email" label="メールアドレス" type="email" />
              <MyTextInput name="phone" label="電話番号(半角)" type="text" />
              <MyTextArea
                name="description"
                label="お問い合わせ内容"
                minRows="6"
              />

              <PrivacyAgreement />

              <Box sx={{ my: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  }
                  label="同意する。"
                />
              </Box>

              <Button
                disabled={isSubmitting || !dirty || !isValid || !checked}
                // type="submit"
                color="primary"
                size="large"
                variant="contained"
                onClick={() => {
                  setInquiry(values)
                  setOpen(true)
                }}
              >
                確認する
              </Button>

              <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="md"
              >
                <Typography
                  variant="h6"
                  sx={{ textAlign: "center", mt: "2em" }}
                >
                  以下の内容で送信します。宜しければ「送信する」ボタンをクリックして下さい。
                  <br />
                  修正する場合は「戻る」ボタンをクリックして下さい。
                </Typography>
                <DialogContent sx={{ mx: "5em" }}>
                  <Typography variant="body1" sx={{ mt: "1em" }}>
                    お名前：{inquiry.name}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: "1em" }}>
                    企業名：{inquiry.company}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: "1em" }}>
                    メールアドレス： {inquiry.email}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: "1em" }}>
                    電話番号：{inquiry.phone}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: "1em" }}>
                    お問い合わせ内容：
                  </Typography>
                  <Typography variant="body1">{inquiry.description}</Typography>
                </DialogContent>
                <Box sx={{ alignSelf: "center", mb: "2em" }}>
                  <Button
                    variant="outlined"
                    onClick={() => setOpen(false)}
                    sx={{ mr: "1em" }}
                  >
                    戻る
                  </Button>
                  <LoadingButton
                    variant="outlined"
                    loading={loading}
                    onClick={submitForm}
                    autoFocus
                  >
                    送信する
                  </LoadingButton>
                </Box>
              </Dialog>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  )
}
